import { useSelector, useDispatch } from "react-redux";
import { Betbar } from "@low6dev/react-feature-betbar/dist";
import { handleError } from "@low6dev/react-utils";
import history from "router/history";
import { setApp } from "components/feature/app/actions";
import { setAuth } from "components/feature/auth/actions";
import { useTranslations } from "hooks";
import { setBetbarParent } from "components/feature/betbar/actions";

const Wrapper = ({
  picksData,
  setPicksData,
  isLeaderboard,
  onClearButtonClicked,
  onHelpButtonClicked,
  ...rest
}) => {
  const dispatch = useDispatch();

  const [translations] = useTranslations();

  const betbarParent = useSelector((s) => s.betbarParent);

  const app = useSelector((s) => s.app);

  const { isLoggedIn } = useSelector((s) => s.auth);

  const handleSetApp = (app) => {
    dispatch(setApp(app));
  };

  const handleSetBetbarParent = (betbar) => {
    dispatch(setBetbarParent(betbar));
  };

  const handleLoginButtonClicked = () => {
    dispatch(
      setAuth({
        placeBetData: undefined,
      })
    );
    history.push("/login");
  };

  const handleSignupButtonClicked = () => {
    history.push("/signup");
  };

  const handleLogoutButtonClicked = () => {
    localStorage.removeItem("fiver_react_access_token");
    window.location.href = "/";
  };

  console.log("picksData", picksData);

  return (
    <Betbar
      {...rest}
      onClearButtonClicked={onClearButtonClicked}
      onHelpButtonClicked={onHelpButtonClicked}
      onLoginButtonClicked={handleLoginButtonClicked}
      onLogoutButtonClicked={handleLogoutButtonClicked}
      onSignupButtonClicked={handleSignupButtonClicked}
      translations={translations}
      isDpg={true}
      isLoggedIn={isLoggedIn}
      disableDropdown={true}
      showNavigationArrows={true}
      isLeaderboard={isLeaderboard}
      isUsingAlternativeImages
      hideLeaderboardRow={true}
      showOnlyFixture
      showLoginButton={
        process.env.REACT_APP_BETBAR_SHOW_LOGIN_BUTTON === "true" && !isLoggedIn
      }
      hideHelp={true}
      onError={handleError}
      app={app}
      setApp={handleSetApp}
      betbarParent={betbarParent}
      setBetbarParent={handleSetBetbarParent}
      history={history}
      getLeaderboard={() => console.log("getLeaderboard")}
      progressTotal={picksData?.questionsTotal}
      progressCurrent={picksData?.questionsAnswered}
    />
  );
};

export default Wrapper;
